const shortcut = (e) => {
  // console.log(e.key, e.code);
  // console.log(e.target, document.activeElement);
  const notWriting = ['text', 'textarea'].indexOf(e.target.type) < 0;
  if (notWriting) switch (e.code) {
    case 'Escape':
      // console.log('Avbryt');
      const created = typeof cancelDrawingBtn !== 'undefined';
      if (created && cancelDrawingBtn.checkVisibility()) cancelDrawingBtn.click();
      if (regretButton.checkVisibility()) regretButton.click(); // eksisterende
      if (lukkBtn.checkVisibility()) lukkBtn.click();
      break;
    case 'KeyA':
      // console.log('Angre');
      if (regretNewLineBtn.checkVisibility()) regretNewLineBtn.click();
      if (backButton.checkVisibility()) backButton.click();
      break;
    case 'KeyB':
      // console.log('Bekreft endringer');
      if (confirmButton.checkVisibility()) confirmButton.click();
      break;
    case 'KeyE':
      // console.log('Endre');
      document.getElementById('geometry-change-attributes').click();
      break;
    case 'KeyF':
      // console.log('Ferdig');
      if (ferdigBtn.checkVisibility()) ferdigBtn.click();
      break;
    // case 'KeyG':
    //   // console.log('Fjern grense');
    //   break;
    case 'KeyI':
      // console.log('Info');
      toolbar_info.click();
      break;
    case 'KeyL':
      // console.log('Lagre endringer');
      if (saveNewLineBtn.checkVisibility()) saveNewLineBtn.click(); // ny flate
      if (doneButton.checkVisibility()) doneButton.click(); // eksisterende flate
      break;
    case 'KeyG':
    case 'KeyM':
      // console.log('Slå sammen');
      if (mergeBtn.checkVisibility()) mergeBtn.click();
      break;
    case 'KeyP':
      // console.log('Angre siste punkt');
      if (deleteLastDrawnPointBtn.checkVisibility()) deleteLastDrawnPointBtn.click();
      break;
    case 'KeyS':
      // console.log('Søk');
      toolbar_search.click();
      break;
    case 'KeyT':
      // console.log('Tegn');
      document.getElementById('geometry-change').click();
      break;
    default:
      // console.log(e.code);
  }
};

export const listenToShortcuts = () =>
  document.addEventListener('keyup', shortcut, false);
